export const translations = {
  es: {
    nav: {
      features: "Funciones",
      how: "Cómo Funciona",
      partner: "Socios",
      mission: "Misión",
      app: "App",
      contact: "Contacto",
    },
    hero: {
      badge: "Disponible en Costa Rica",
      title1: "Rescatá comida.",
      title2: "Ahorrá dinero.",
      subtitle:
        "Bolsita Verde es la app que conecta restaurantes, panaderías, sodas y floristerías con personas como vos. Recogés comida (y hasta flores) que sobra al final del día a hasta 50% menos — todo en perfecto estado para consumir.",
      ctaPrimary: "Únete Ahora",
      ctaSecondary: "Cómo Funciona",
      badgeSave: "Ahorra 50%",
      badgeSaveSub: "en cada bolsita",
      badgeWaste: "-40%",
      badgeWasteSub: "Desperdicio alimentario",
      alt: "Bolsitas de comida rescatada con vegetales y frutas frescas",
    },
    marquee: [
      "Comida de calidad",
      "Precios reducidos",
      "Negocios locales",
      "Impacto ambiental real",
      "Fácil de usar",
      "100% Costa Rica",
    ],
    audience: {
      eyebrow: "¿Para quién es?",
      title: "Una app, dos formas de ganar",
      subtitle:
        "Bolsita Verde conecta a quienes buscan buena comida a mejor precio con negocios que quieren aprovechar cada plato.",
      users: {
        label: "Para vos",
        title: "Buena comida (y flores) a mitad de precio",
        bullets: [
          "Productos frescos y en perfecto estado para consumir — solo son excedentes del día",
          "No solo comida: también panadería, repostería, flores y más",
          "Ahorrás hasta 50% del precio original en cada bolsita",
          "Descubrí restaurantes, panaderías, sodas y floristerías cerca tuyo",
          "Reservás en la app y recogés en el local con un código QR",
          "Sin suscripción — pagás solo lo que querés",
        ],
        cta: "Descargar la app",
        ctaHref: "#app",
      },
      partners: {
        label: "Para tu negocio",
        title: "Convertí el excedente diario en ingresos",
        bullets: [
          "Ganás con la comida que hoy termina en la basura",
          "Atraés nuevos clientes que descubren tu marca en la app",
          "Registro y uso 100% gratis — sin costos fijos",
          "Publicás bolsitas en segundos desde tu panel",
          "Mejorás tu impacto y tu imagen sin cambiar tu operación",
        ],
        cta: "Ser socio",
        ctaHref: "#contact",
      },
    },
    goals: {
      eyebrow: "Nuestras Metas",
      title: "Lo que queremos lograr juntos",
      subtitle:
        "Estamos comenzando esta aventura. Estas son las metas que nos hemos propuesto — y contigo podemos alcanzarlas.",
      items: [
        { value: "800 kg", label: "de comida rescatada en el primer mes" },
        { value: "1,200+", label: "bolsitas salvadas en los primeros 6 meses" },
        { value: "50+", label: "socios locales en el primer año" },
        { value: "2.4 ton", label: "de CO₂ evitado en el primer año" },
      ],
    },
    features: {
      eyebrow: "Por qué Bolsita Verde",
      title: "Comida increíble. Precios increíbles.",
      subtitle:
        "Descubre cómo nuestra app transforma el excedente de comida en oportunidades para todos.",
      items: [
        {
          icon: "PiggyBank",
          title: "Ahorra hasta un 50%",
          text: "Compra bolsitas sorpresa con comida de calidad de tus restaurantes favoritos a una fracción del precio original.",
        },
        {
          icon: "Sprout",
          title: "Impacto Ambiental Real",
          text: "Cada bolsita rescatada evita que comida perfectamente buena termine en un relleno sanitario, reduciendo las emisiones de CO₂.",
        },
        {
          icon: "MapPin",
          title: "Descubre lo Local",
          text: "Explora restaurantes, panaderías y sodas cerca de ti. Cada bolsita es una sorpresa deliciosa de negocios locales.",
        },
        {
          icon: "BellRing",
          title: "Notificaciones Inteligentes",
          text: "Recibe alertas cuando hay nuevas bolsitas disponibles cerca de ti o de tus restaurantes favoritos.",
        },
        {
          icon: "Smartphone",
          title: "Fácil de Usar",
          text: "Reserva tu bolsita en segundos, recibe un código QR y recógela en el local. Así de simple.",
        },
        {
          icon: "Croissant",
          title: "Variedad de productos",
          text: "No solo restaurantes: también panaderías, reposterías, sodas, floristerías y más. Cada bolsita es una nueva sorpresa.",
        },
      ],
    },
    how: {
      eyebrow: "Paso a paso",
      title: "Cómo funciona Bolsita Verde",
      steps: [
        {
          title: "Explora",
          text: "Abre la app y descubre las bolsitas sorpresa disponibles de restaurantes cerca de ti.",
        },
        {
          title: "Reserva",
          text: "Elige tu bolsita favorita y resérvala con un toque. Recibirás un código QR de confirmación.",
        },
        {
          title: "Recoge y Disfruta",
          text: "Pasa por el restaurante en la ventana de recogida, muestra tu código y disfruta tu bolsita sorpresa.",
        },
      ],
    },
    partner: {
      eyebrow: "Para Restaurantes y Comercios",
      title: "Convierte tu excedente en ingresos",
      subtitle:
        "Únete como socio de Bolsita Verde y transforma la comida que normalmente desperdicias en una nueva fuente de ingresos, mientras atraes nuevos clientes a tu negocio.",
      bullets: [
        "Genera ingresos adicionales con productos que normalmente se pierden",
        "Atrae nuevos clientes a tu negocio a través de la app",
        "Reduce tu huella de carbono y mejora tu imagen de marca",
        "Dashboard de administración con analítica detallada",
        "Registro gratuito y soporte personalizado",
      ],
      cta: "Regístra tu Negocio",
      badge: "Registro gratuito",
      alt: "Panadería socia de Bolsita Verde preparando bolsitas de comida",
    },
    mission: {
      eyebrow: "Nuestra Misión",
      title: "Un Costa Rica sin desperdicio alimentario",      quote:
        "Cada año, más de 1 millón de toneladas de comida se desperdician en Costa Rica. Nosotros creemos que cada plato merece una segunda oportunidad.",
      body1:
        "En Bolsita Verde, nos mueve la convicción de que la tecnología puede ser una herramienta poderosa para combatir el desperdicio alimentario. Conectamos negocios locales con consumidores conscientes, creando un ecosistema donde todos ganan.",
      body2:
        "Nuestra visión es un futuro donde ningún alimento en buen estado termine en la basura. Cada bolsita rescatada es un paso hacia ese futuro.",
      stats: [],
    },
    community: {
      eyebrow: "Nuestra Comunidad",
      title: "Más que una app — una comunidad que rescata",
      body:
        "En Bolsita Verde soñamos con un Costa Rica más verde, más justo y más humano. No queremos hacerlo solos. Por eso extendemos la mano a restaurantes, panaderías, sodas y a cada persona que cree que los pequeños gestos también cambian el mundo. Juntos apoyamos proyectos sociales y ecológicos locales, cuidamos nuestra tierra y construimos una comunidad que rescata comida hoy para dejar un mejor mañana.",
      highlight: "Sé parte del viaje. Esta historia recién empieza — y sin vos, no es la misma.",
      cta: "Sumate a la comunidad",
    },
    app: {
      eyebrow: "Descarga la app",
      title: "Tu próxima bolsita, a un toque de distancia",
      subtitle:
        "¡Ya disponible en iOS y Android! Descargá Bolsita Verde y empezá a rescatar comida hoy.",
      android: "Google Play",
      ios: "App Store",
      soon: "Próximamente",
      preOrder: "Avísame al lanzamiento",
    },
    contact: {
      eyebrow: "Contacto",
      title: "Hablemos",
      subtitle:
        "¿Tienes preguntas, quieres ser socio o simplemente quieres saber más? Escríbenos y te respondemos en menos de 24 horas.",
      email: "Email",
      location: "Ubicación",
      locationValue: "San José, Costa Rica",
      web: "Web",
      webValue: "www.tu-bolsitaverdecr.com",
      form: {
        name: "Nombre completo",
        email: "Email",
        type: "Tipo de consulta",
        types: [
          "Consulta general",
          "Quiero ser socio / restaurante",
          "Soporte técnico",
          "Prensa / Medios",
        ],
        restaurant: "Nombre del restaurante",
        whatsapp: "Número de WhatsApp",
        optional: "opcional",
        message: "Mensaje",
        submit: "Enviar Mensaje",
        sending: "Enviando...",
        successTitle: "¡Mensaje enviado!",
        successText:
          "Gracias por contactarnos. Te responderemos pronto en tu correo.",
        errorTitle: "Algo salió mal",
        errorText:
          "No pudimos enviar tu mensaje. Por favor, intenta de nuevo o escríbenos directamente.",
      },
    },
    footer: {
      tagline: "Rescatando comida, salvando el planeta. Una bolsita a la vez.",
      nav: "Navegación",
      legal: "Legal",
      app: "Descargar App",
      privacy: "Política de Privacidad",
      terms: "Términos y Condiciones",
      soon: "Próximamente",
      rights: "Todos los derechos reservados.",
      followUs: "Síguenos",
    },
  },

  en: {
    nav: {
      features: "Features",
      how: "How it works",
      partner: "Partners",
      mission: "Mission",
      app: "App",
      contact: "Contact",
    },
    hero: {
      badge: "Available in Costa Rica",
      title1: "Rescue food.",
      title2: "Save money.",
      subtitle:
        "Bolsita Verde is the app that connects restaurants, bakeries, sodas and flower shops with people like you. Pick up food (and even flowers) that's left over at the end of the day for up to 50% less — all in perfect condition to enjoy.",
      ctaPrimary: "Join Now",
      ctaSecondary: "How it works",
      badgeSave: "Save 50%",
      badgeSaveSub: "on every bag",
      badgeWaste: "-40%",
      badgeWasteSub: "Food waste",
      alt: "Rescued food bags with fresh vegetables and fruits",
    },
    marquee: [
      "Quality food",
      "Reduced prices",
      "Local businesses",
      "Real environmental impact",
      "Easy to use",
      "100% Costa Rica",
    ],
    audience: {
      eyebrow: "Who is it for?",
      title: "One app, two ways to win",
      subtitle:
        "Bolsita Verde connects people looking for great food at better prices with businesses that want to make the most of every plate.",
      users: {
        label: "For you",
        title: "Great food (and flowers) at half the price",
        bullets: [
          "Fresh products in perfect condition to consume — just leftovers from the day",
          "Not only food: also bakery, pastries, flowers and more",
          "Save up to 50% off the original price on every bag",
          "Discover restaurants, bakeries, sodas and flower shops near you",
          "Reserve in the app and pick up in-store with a QR code",
          "No subscription — pay only for what you want",
        ],
        cta: "Download the app",
        ctaHref: "#app",
      },
      partners: {
        label: "For your business",
        title: "Turn daily surplus into revenue",
        bullets: [
          "Earn from food that would otherwise be thrown away",
          "Attract new customers who discover your brand in the app",
          "100% free to register and use — no fixed costs",
          "Publish bags in seconds from your dashboard",
          "Improve your impact and image without changing operations",
        ],
        cta: "Become a partner",
        ctaHref: "#contact",
      },
    },
    goals: {
      eyebrow: "Our Goals",
      title: "What we want to achieve together",
      subtitle:
        "We're just getting started. These are the goals we've set — and with you, we can reach them.",
      items: [
        { value: "800 kg", label: "of food rescued in our first month" },
        { value: "1,200+", label: "bags saved in the first 6 months" },
        { value: "50+", label: "local partners in the first year" },
        { value: "2.4 ton", label: "of CO₂ avoided in the first year" },
      ],
    },
    features: {
      eyebrow: "Why Bolsita Verde",
      title: "Amazing food. Amazing prices.",
      subtitle:
        "Discover how our app turns food surplus into opportunity for everyone.",
      items: [
        {
          icon: "PiggyBank",
          title: "Save up to 50%",
          text: "Buy surprise bags with quality food from your favorite restaurants at a fraction of the original price.",
        },
        {
          icon: "Sprout",
          title: "Real environmental impact",
          text: "Every rescued bag prevents perfectly good food from ending up in a landfill, reducing CO₂ emissions.",
        },
        {
          icon: "MapPin",
          title: "Discover local",
          text: "Explore restaurants, bakeries and sodas near you. Every bag is a delicious surprise from local businesses.",
        },
        {
          icon: "BellRing",
          title: "Smart notifications",
          text: "Get alerts when new bags are available near you or from your favorite restaurants.",
        },
        {
          icon: "Smartphone",
          title: "Easy to use",
          text: "Reserve your bag in seconds, get a QR code and pick it up at the shop. That simple.",
        },
        {
          icon: "Croissant",
          title: "A variety of products",
          text: "Not only restaurants: also bakeries, pastry shops, sodas, flower shops and more. Every bag is a fresh surprise.",
        },
      ],
    },
    how: {
      eyebrow: "Step by step",
      title: "How Bolsita Verde works",
      steps: [
        {
          title: "Explore",
          text: "Open the app and discover available surprise bags from restaurants near you.",
        },
        {
          title: "Reserve",
          text: "Pick your favorite bag and reserve it with one tap. You'll get a QR confirmation code.",
        },
        {
          title: "Pick up & enjoy",
          text: "Stop by the restaurant during the pickup window, show your code and enjoy your surprise bag.",
        },
      ],
    },
    partner: {
      eyebrow: "For restaurants and shops",
      title: "Turn your surplus into revenue",
      subtitle:
        "Join Bolsita Verde as a partner and transform food you normally waste into a new revenue stream, while attracting new customers to your business.",
      bullets: [
        "Generate extra revenue with products that usually go to waste",
        "Attract new customers to your business through the app",
        "Reduce your carbon footprint and improve your brand image",
        "Admin dashboard with detailed analytics",
        "Free registration and personalized support",
      ],
      cta: "Register your business",
      badge: "Free to register",
      alt: "Bolsita Verde partner bakery preparing food bags",
    },
    mission: {
      eyebrow: "Our mission",
      title: "A Costa Rica without food waste",
      quote:
        "Every year, more than 1 million tons of food are wasted in Costa Rica. We believe every plate deserves a second chance.",
      body1:
        "At Bolsita Verde we're driven by the belief that technology can be a powerful tool against food waste. We connect local businesses with conscious consumers, creating an ecosystem where everyone wins.",
      body2:
        "Our vision is a future where no good food ends up in the trash. Every rescued bag is a step toward that future.",
      stats: [],
    },
    community: {
      eyebrow: "Our Community",
      title: "More than an app — a community that rescues",
      body:
        "At Bolsita Verde we dream of a greener, fairer and more human Costa Rica. We don't want to do it alone. That's why we reach out to restaurants, bakeries, sodas and every person who believes that small gestures can change the world too. Together we support local social and ecological projects, care for our land and build a community that rescues food today to leave a better tomorrow.",
      highlight: "Be part of the journey. This story is just beginning — and without you, it wouldn't be the same.",
      cta: "Join the community",
    },
    app: {
      eyebrow: "Download the app",
      title: "Your next bag, one tap away",
      subtitle:
        "Now available on iOS and Android! Download Bolsita Verde and start rescuing food today.",
      android: "Google Play",
      ios: "App Store",
      soon: "Coming soon",
      preOrder: "Notify me at launch",
    },
    contact: {
      eyebrow: "Contact",
      title: "Let's talk",
      subtitle:
        "Questions, want to be a partner, or just want to know more? Write to us and we'll answer within 24 hours.",
      email: "Email",
      location: "Location",
      locationValue: "San José, Costa Rica",
      web: "Web",
      webValue: "www.tu-bolsitaverdecr.com",
      form: {
        name: "Full name",
        email: "Email",
        type: "Inquiry type",
        types: [
          "General inquiry",
          "I want to be a partner / restaurant",
          "Technical support",
          "Press / Media",
        ],
        restaurant: "Restaurant name",
        whatsapp: "WhatsApp number",
        optional: "optional",
        message: "Message",
        submit: "Send message",
        sending: "Sending...",
        successTitle: "Message sent!",
        successText:
          "Thanks for reaching out. We'll get back to you in your inbox soon.",
        errorTitle: "Something went wrong",
        errorText:
          "We couldn't send your message. Please try again or email us directly.",
      },
    },
    footer: {
      tagline: "Rescuing food, saving the planet. One bag at a time.",
      nav: "Navigation",
      legal: "Legal",
      app: "Download App",
      privacy: "Privacy Policy",
      terms: "Terms & Conditions",
      soon: "Coming soon",
      rights: "All rights reserved.",
      followUs: "Follow us",
    },
  },
};
